module.exports = __webpack_public_path__ + "static/media/HeroBg.53290345.png";